import {
  SIGN_IN,
  SIGN_OUT,
  UPDATE_OFFSET,
  SET_CURRENT_PAGINATION_CONFIG,
  SET_SCREEN_SCROLL_OFFSET,
  SET_CATEGORIES_SORTING_MODE,
  SET_BANNER_IS_OPEN,
} from './constants'
import { DEFAULT_SETTINGS } from '../../utils/paginationCoordinator'

const initialState = {
  offset: DEFAULT_SETTINGS.offset,
}

const state = (state = initialState, { type, payload }) => {
  switch (type) {
    case SIGN_IN: {
      return {
        ...state,
        user: {
          ...payload,
        },
      }
    }

    case SIGN_OUT: {
      return {
        ...state,
        user: initialState.user,
      }
    }

    case UPDATE_OFFSET: {
      return {
        ...state,
        offset: payload,
      }
    }

    case SET_CURRENT_PAGINATION_CONFIG: {
      const { screen, page, per } = payload

      return {
        ...state,
        screenPaginationPage: {
          [screen]: { page, per },
        },
      }
    }

    case SET_SCREEN_SCROLL_OFFSET: {
      const { screen, offset } = payload

      return {
        ...state,
        screenScrollOffset: {
          ...state.screenScrollOffset,
          [screen]: offset,
        },
      }
    }

    case SET_CATEGORIES_SORTING_MODE: {
      return {
        ...state,
        categoriesSortingMode: payload,
      }
    }

    case SET_BANNER_IS_OPEN: {
      const { value, route } = payload

      return {
        ...state,
        banner: {
          [route]: {
            isOpenBanner: value,
          },
        },
      }
    }

    default:
      return state
  }
}

export default state
